import { createSlice } from '@reduxjs/toolkit';

export const athleteGroupScheduleSlice = createSlice({
	name: 'athleteGroupSchedule',
	initialState: {
		reload: null,
	},
	reducers: {
		setAthleteGroupScheduleReload: (state, action) => {
			state.reload = action.payload;
		},
	},
});

export const { setAthleteGroupScheduleReload } =
	athleteGroupScheduleSlice.actions;

export default athleteGroupScheduleSlice.reducer;
